import Vue from "vue";
import Vuex from "vuex";
import Advisory from "./advisory";

Vue.use(Vuex);

const store = new Vuex.Store(Advisory);

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js